import React from "react";
import "./Modal.css";
import { Modal as SharedModal } from "@preppa/shared-ui";
//SKAPA Styles
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/focus/dist/style.css";

interface ModalProps {
  isModalOpen?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
}

function Modal({ isModalOpen, onClose, children }: ModalProps) {
  return (
    <SharedModal
      isModalOpen={isModalOpen}
      onClose={onClose}
      containerClassName="modal-wrapper"
      contentClassName="modal-content-container"
    >
      {children}
    </SharedModal>
  );
}

export default Modal;
